/**
 * Generation guard for an async download. begin() opens a download and returns its generation;
 * bump() invalidates whatever is in flight (selection, account, language or permission changed);
 * a late response may act only while isCurrent(gen) is true.
 */
export function createDownloadGuard() {
  let gen = 0;
  return {
    bump() {
      gen += 1;
    },
    begin() {
      gen += 1;
      return gen;
    },
    isCurrent(g) {
      return g === gen;
    },
  };
}
